var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9651 13.1006C44.111 13.1006 43.4186 13.793 43.4186 14.6471V21.2891L39.4879 21.2891V14.6471C39.4879 13.793 38.7955 13.1006 37.9414 13.1006H31.272V9.16988H37.9414C38.7955 9.16988 39.4879 8.47749 39.4879 7.62337V0.954043L43.4186 0.954042V7.62337C43.4186 8.47749 44.111 9.16988 44.9651 9.16988H51.6344L51.6344 13.1006H44.9651ZM35.2028 24.0551C35.2028 24.9092 35.8951 25.6016 36.7493 25.6016H43.4186V46.7372C43.4186 49.3226 41.3 51.4412 38.7146 51.4412H5.85125C3.26583 51.4412 1.14728 49.3226 1.14728 46.7372V13.8739C1.14728 11.2884 3.26583 9.16988 5.85125 9.16988L26.9869 9.16989V15.8392C26.9869 16.6933 27.6793 17.3857 28.5334 17.3857H35.2028V24.0551ZM6.16055 45.0361C5.39592 46.0556 6.12337 47.5105 7.39776 47.5105H37.1058C38.4025 47.5105 39.1235 46.0105 38.3134 44.9979L28.9875 33.3405C28.356 32.5511 27.1492 32.57 26.5427 33.3787L19.5815 42.6603L15.3167 36.2632C14.7248 35.3754 13.433 35.3395 12.7927 36.1931L6.16055 45.0361Z",
    stroke: "#B8B8B8",
    strokeWidth: 1.54651
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoAdd);
export default __webpack_public_path__ + "static/media/photoAdd.4eb431833154a5a2efa64540fe073544.svg";
export { ForwardRef as ReactComponent };